import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";
import { httpsBaseUrl } from "../https-base-url";

const smartPackBaseUrl = httpsBaseUrl(
  "SmartPack API URL must be an https smartpack.dk URL, for example https://tenant.smartpack.dk/api/v1",
  (hostname) => hostname.endsWith(".smartpack.dk"),
);

const required = (label: string) =>
  z.string().trim().min(1, `${label} is required`);

const smartPackId = (label: string) =>
  required(label).pipe(z.guid(`${label} must be a SmartPack ID (GUID)`));

export const smartPackSettings = defineIntegrationSettings({
  fields: {
    baseUrl: smartPackBaseUrl,
    appId: smartPackId("App ID"),
    // SmartPack matches delivery method keys exactly, including case.
    defaultDeliveryMethod: required("Return delivery method key"),
    carrierDeliveryMethods: z.array(
      z.object({
        carrier: required("Carrier"),
        deliveryMethod: required("Delivery method key"),
      }),
    ),
    defaultReturnReasonId: smartPackId("Default return reason ID"),
    warehouseReasonMap: z.array(
      z.object({
        redoReason: required("Redo reason"),
        smartPackReasonId: smartPackId("SmartPack reason ID"),
      }),
    ),
    returnActionId: smartPackId("Return action ID"),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
  },
  secrets: {
    accessToken: required("Access token"),
    secretKey: z.string().trim().min(1).optional(),
  },
  connectOnly: {},
  computed: {},
});
